import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@mui/material'

const IconTool = ({
    icon,
    toolIcon,
    height,
    width,
    tooltip,
    setTool,
    iconSelected,
}) => {
    return (
        <li style={{ display: 'inline-block' }}>
            <Tooltip title={tooltip}>
                <img
                    className={`validationIcon clickable no-margin ${toolIcon === iconSelected && 'activated'}`}
                    style={{ height, width }}
                    onClick={() => setTool(toolIcon)}
                    src={icon}
                />
            </Tooltip>
        </li>
    )
}

IconTool.propTypes = {
    icon: PropTypes.string,
    toolIcon: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    tooltip: PropTypes.string,
    setTool: PropTypes.func,
    iconSelected: PropTypes.string,
}

export default IconTool